import type { LogoPosition } from "@juegossc/shared";
import {
  LandingView,
  type LandingViewGlobal,
  type LandingViewSettings,
  type LandingViewCampana,
} from "../../landing/LandingView";
import { VirtualScreen } from "./VirtualScreen";
import { buildBackgroundStyle } from "../../../hooks/useBackgroundStyle";

// Preview 100% FIEL de la pantalla principal. Renderiza el MISMO LandingView
// que ve el cliente, sobre el MISMO lienzo de referencia que usa la pantalla
// real (FitScreen). Por eso lo que se ajusta acá se ve TAL CUAL en la pantalla,
// a CUALQUIER resolución (1080, 4K o intermedia) — sin elegir nada: la
// proporción del logo/íconos/campaña es idéntica. `guides` dibuja los
// rectángulos punteados de margen.
export function PantallaPreview({
  bgUrl,
  campana,
  logoUrl,
  logoWidthPx,
  logoPosition,
  logoTopMarginPx,
  campanaMaxHeightPx,
  campanaTopMarginPx,
  iconRuletaUrl,
  iconRaspaditaUrl,
  iconMemoriaUrl,
  iconSizePx,
  gapPx,
  verticalPosPct,
  hAlign,
  fontHeading,
  fontBody,
  fontDisplay,
  ruletaSlots,
  guides = true,
}: {
  bgUrl: string | null;
  campana: LandingViewCampana;
  ruletaSlots?: number;
  logoUrl: string | null;
  logoWidthPx: number;
  logoPosition: LogoPosition;
  logoTopMarginPx: number;
  campanaMaxHeightPx: number;
  campanaTopMarginPx: number;
  iconRuletaUrl: string | null;
  iconRaspaditaUrl: string | null;
  iconMemoriaUrl: string | null;
  iconSizePx: number;
  gapPx: number;
  verticalPosPct: number;
  hAlign: "left" | "center" | "right";
  fontHeading: string;
  fontBody: string;
  fontDisplay: string;
  guides?: boolean;
}) {
  // Shape de global_settings que lee el landing, con valores EN VIVO del form.
  const global: LandingViewGlobal = {
    logo_url: logoUrl,
    logo_width_px: logoWidthPx,
    logo_position: logoPosition,
    landing_logo_top_margin_px: logoTopMarginPx,
    campana_max_height_px: campanaMaxHeightPx,
    landing_campana_top_margin_px: campanaTopMarginPx,
    landing_campana_to_iconos_gap_px: gapPx,
    landing_vertical_pos_pct: verticalPosPct,
    landing_iconos_horizontal_align: hAlign,
    landing_icon_size_px: iconSizePx,
    icon_ruleta_url: iconRuletaUrl,
    icon_raspadita_url: iconRaspaditaUrl,
    icon_memoria_url: iconMemoriaUrl,
  };
  const settings: LandingViewSettings = {
    modo_prueba: false,
    ruleta_habilitada: true,
    raspadita_habilitada: true,
    memoria_habilitada: true,
  };
  // Fondo con el MISMO overlay que la pantalla real (portrait).
  const bgStyle = buildBackgroundStyle(
    { bg_portrait_url: bgUrl, bg_landscape_url: null },
    false,
  );
  return (
    <div
      className="flex h-full w-full items-center justify-center"
      // CSS vars de tipografía para reflejar la fuente elegida EN VIVO (las
      // clases font-heading/font-display del landing las leen). Solo cascadea
      // a este preview.
      style={
        {
          ["--font-heading"]: `"${fontHeading}", "Nunito", sans-serif`,
          ["--font-body"]: `"${fontBody}", "Nunito", sans-serif`,
          ["--font-display"]: `"${fontDisplay}", "Nunito", sans-serif`,
        } as React.CSSProperties
      }
    >
      <VirtualScreen bgStyle={bgStyle}>
        <LandingView
          global={global}
          settings={settings}
          campana={campana}
          preview
          guides={guides}
          ruletaSlots={ruletaSlots}
        />
      </VirtualScreen>
    </div>
  );
}
